import { getErrorMessage } from '../adapters/error.adapter';
import { DisplayProperties } from '../models';
import { ErrorMessages } from './aem/error-messages.mock';

export const EmptyObjectMock: DisplayProperties = {
  disabled: true,
  loaded: false,
  error: undefined
};

export const EmptyErrorObjectMock = (error: string): DisplayProperties => {
  return {
    disabled: true,
    loaded: true,
    error: getErrorMessage(error, ErrorMessages)
  };
};

export const EmptyStateMock = {
  entities: {},
  ids: [],
  loaded: false
};
